import { createJSONRequest } from './create-request'

export const fetchBootData = () => createJSONRequest({
  url: '/api/boot',
  method: 'GET',
})
